"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const data_1 = require("../../../data");
const usefulAddressCreate = (0, graphql_tag_1.default)`
  ${data_1.userMiniPopupSchemaFields}
  mutation useful_address_edit($addressData: UsefulAddressDataEditInput!, $addressId: Int!) {
    usefulAddress {
      edit(addressData: $addressData, addressId: $addressId) {
        id
        title
        address
        shortAddress
        lat
        lng
        isFavorite
        author {
          ...userMiniPopupSchemaFields
        }
        description
        phones {
          phone
          description
        }
        web
        email
        tags
        review {
          ratingAvg
          count
          fromCurrentUser
        }
        canEdit
        canDelete
      }
    }
  }
`;
exports.default = usefulAddressCreate;